export interface ColorSetting {
  name: string;
  vars: string[];
  id: string;
  category: ColorCategory;
}

export enum ColorCategory {
  General = 'General',
  Sidebar = 'Sidebar',
  Card = 'Card',
  Overlay = 'Overlay',
  Border = 'Border',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Tertiary = 'Tertiary',
  Disabled = 'Disabled',
  Map = 'Map'
}

export const themeColors: ColorSetting[] = [
  // General
  {
    id: 'foreground',
    name: 'Foreground',
    vars: ['--color-foreground'],
    category: ColorCategory.General
  },
  {
    id: 'background',
    name: 'Background',
    vars: ['--v2-background'],
    category: ColorCategory.General
  },

  // Sidebar
  {
    id: 'sidebarBackground',
    name: 'Sidebar Background',
    vars: ['--v2-sidebar-background'],
    category: ColorCategory.Sidebar
  },
  {
    id: 'sidebarForeground',
    name: 'Sidebar Foreground',
    vars: ['--color-primary-bg'],
    category: ColorCategory.Sidebar
  },
  {
    id: 'sidebarIcons',
    name: 'Sidebar Icons',
    vars: ['--v2-sidebar-icons'],
    category: ColorCategory.Sidebar
  },
  {
    id: 'sidebarIconsSelected',
    name: 'Sidebar Icons Selected / Hover',
    vars: ['--v2-sidebar-icons-selected'],
    category: ColorCategory.Sidebar
  },

  // Card
  {
    id: 'cardBackground',
    name: 'Card Background',
    vars: ['--color-card-background'],
    category: ColorCategory.Card
  },
  {
    id: 'cardForeground',
    name: 'Card Foreground',
    vars: ['--color-card-foreground'],
    category: ColorCategory.Card
  },

  // Overlay
  {
    id: 'overlayBackground',
    name: 'Overlay Background',
    vars: ['--color-overlay-background'],
    category: ColorCategory.Overlay
  },
  {
    id: 'overlayForeground',
    name: 'Overlay Foreground',
    vars: ['--color-overlay-foreground'],
    category: ColorCategory.Overlay
  },

  // Border
  {
    id: 'borderPrimary',
    name: 'Border Primary',
    vars: ['--color-border-primary'],
    category: ColorCategory.Border
  },
  {
    id: 'borderSecondary',
    name: 'Border Secondary',
    vars: ['--color-border-secondary'],
    category: ColorCategory.Border
  },
  {
    id: 'borderSidebar',
    name: 'Border Sidebar',
    vars: ['--color-border-sidebar'],
    category: ColorCategory.Border
  },

  // Primary
  {
    id: 'primary',
    name: 'Primary',
    vars: ['--color-primary'],
    category: ColorCategory.Primary
  },
  {
    id: 'primaryForeground',
    name: 'Primary Foreground',
    vars: ['--color-primary-text', '--color-primary-foreground'],
    category: ColorCategory.Primary
  },
  /*{
      id: 'primaryHover',
      name: 'Primary Hover',
      vars: ['--color-primary-hover'],
      category: ColorCategory.Primary
    },*/
  /*{
      id: 'primaryHoverForeground',
      name: 'Primary Hover Foreground',
      vars: ['--color-primary-hover-foreground'],
      category: ColorCategory.Primary
    },*/

  // Secondary
  {
    id: 'secondary',
    name: 'Secondary',
    vars: ['--color-secondary'],
    category: ColorCategory.Secondary
  },
  /*{
      id: 'secondaryHover',
      name: 'Secondary Hover',
      vars: ['--color-secondary-hover'],
      category: ColorCategory.Secondary
    },*/
  {
    id: 'secondaryForeground',
    name: 'Secondary Foreground',
    vars: ['--color-secondary-foreground'],
    category: ColorCategory.Secondary
  },
  /*{
      id: 'secondaryHoverForeground',
      name: 'Secondary Hover Foreground',
      vars: ['--color-secondary-hover-foreground'],
      category: ColorCategory.Secondary
    },*/

  // Tertiary
  {
    id: 'tertiary',
    name: 'Tertiary',
    vars: ['--color-tertiary'],
    category: ColorCategory.Tertiary
  },
  {
    id: 'tertiaryForeground',
    name: 'Tertiary Foreground',
    vars: ['--color-tertiary-foreground'],
    category: ColorCategory.Tertiary
  },
  /*{
      id: 'tertiaryHover',
      name: 'Tertiary Hover',
      vars: ['--color-tertiary-hover'],
      category: ColorCategory.Tertiary
    },*/
  /*{
      id: 'tertiaryHoverForeground',
      name: 'Tertiary Hover Foreground',
      vars: ['--color-tertiary-hover-foreground'],
      category: ColorCategory.Tertiary
    },*/

  // Disabled
  {
    id: 'disabledBackground',
    name: 'Disabled Background',
    vars: ['--color-disabled-background'],
    category: ColorCategory.Disabled
  },
  {
    id: 'disabledForeground',
    name: 'Disabled Foreground',
    vars: ['--color-disabled-foreground'],
    category: ColorCategory.Disabled
  },

  // Map
  {
    id: 'mapSelection',
    name: 'Map Selection',
    vars: ['--color-map-selection'],
    category: ColorCategory.Map
  },
  {
    id: 'mapAvailable',
    name: 'Map Available',
    vars: ['--color-map-available'],
    category: ColorCategory.Map
  },
  {
    id: 'mapNotAvailable',
    name: 'Map Not Available',
    vars: ['--color-map-not-available'],
    category: ColorCategory.Map
  },
  {
    id: 'mapReserved',
    name: 'Map Reserved',
    vars: ['--color-map-reserved'],
    category: ColorCategory.Map
  },
  {
    id: 'mapSelf',
    name: 'Map Self',
    vars: ['--color-map-self'],
    category: ColorCategory.Map
  }
];

export const applyThemeColors = (colors: Record<string, string>) => {
  themeColors.forEach((colorSetting) => {
    const colorValue = colors[colorSetting.id];
    if (colorValue) {
      colorSetting.vars.forEach((varName) => {
        document.body.style.setProperty(varName, colorValue);
      });
    }
  });
};

export const applyThemeFont = (font: string) => {
  const styleId = 'tactic-global-font-style';
  let styleEl = document.getElementById(styleId) as HTMLStyleElement | null;

  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = styleId;
    document.head.appendChild(styleEl);
  }

  styleEl.innerHTML = `.tactic-v2 * { font-family: ${font} !important; }`;
};
